import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

const base: SVGProps<SVGSVGElement> = {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': true,
    focusable: false,
}

export function FormatIcon(props: IconProps) {
    return (
        <svg {...base} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.9999 1.06665C8.2413 1.06665 8.4592 1.21133 8.55288 1.43382L13.8862 14.1005C14.0148 14.4059 13.8715 14.7577 13.5661 14.8863C13.2607 15.0149 12.9088 14.8716 12.7802 14.5661L10.9348 10.1833H5.06495L3.21954 14.5661C3.09095 14.8716 2.73913 15.0149 2.43373 14.8863C2.12832 14.7577 1.98499 14.4059 2.11358 14.1005L7.44691 1.43382C7.54059 1.21133 7.75849 1.06665 7.9999 1.06665ZM5.57021 8.98332H10.4296L7.9999 3.21281L5.57021 8.98332Z"
                fill="#19191A"
            />
        </svg>
    )
}

export function MentionIcon(props: IconProps) {
    return (
        <svg {...base} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.71231 1.52684C7.99258 1.27218 9.31962 1.40288 10.5256 1.90242C11.7316 2.40196 12.7624 3.2479 13.4876 4.33326C14.2128 5.41863 14.5999 6.69467 14.5999 8.00003L14.5999 9.00003C14.5999 10.2519 13.5851 11.2667 12.3332 11.2667C11.5234 11.2667 10.8127 10.842 10.4119 10.2031C9.81454 10.8567 8.9551 11.2667 7.9999 11.2667C6.19577 11.2667 4.73324 9.80416 4.73324 8.00003C4.73324 6.1959 6.19577 4.73336 7.9999 4.73336C8.85609 4.73336 9.63534 5.06275 10.2179 5.60171C10.3278 5.47798 10.4881 5.40003 10.6666 5.40003C10.9979 5.40003 11.2666 5.66866 11.2666 6.00003V8.00003V9.00003C11.2666 9.58913 11.7441 10.0667 12.3332 10.0667C12.9223 10.0667 13.3999 9.58913 13.3999 9.00003V8.00003C13.3999 6.93201 13.0832 5.88797 12.4898 4.99995C11.8965 4.11192 11.0531 3.41979 10.0664 3.01108C9.07967 2.60236 7.99391 2.49543 6.94642 2.70379C5.89892 2.91215 4.93673 3.42645 4.18153 4.18165C3.42632 4.93685 2.91202 5.89904 2.70366 6.94654C2.4953 7.99404 2.60224 9.0798 3.01096 10.0665C3.41967 11.0532 4.1118 11.8966 4.99983 12.49C5.88785 13.0833 6.93189 13.4 7.9999 13.4C8.33127 13.4 8.5999 13.6687 8.5999 14C8.5999 14.3314 8.33127 14.6 7.9999 14.6C6.69455 14.6 5.41851 14.2129 4.33314 13.4877C3.24778 12.7625 2.40184 11.7317 1.9023 10.5257C1.40276 9.31975 1.27206 7.99271 1.52672 6.71243C1.78138 5.43216 2.40997 4.25615 3.333 3.33312C4.25603 2.4101 5.43203 1.78151 6.71231 1.52684ZM10.0666 8.00003C10.0666 6.85864 9.14129 5.93336 7.9999 5.93336C6.85852 5.93336 5.93324 6.85864 5.93324 8.00003C5.93324 9.14142 6.85852 10.0667 7.9999 10.0667C9.14129 10.0667 10.0666 9.14142 10.0666 8.00003Z"
                fill="#19191A"
            />
        </svg>
    )
}

export function ErrorIcon(props: IconProps) {
    return (
        <svg {...base} viewBox="0 0 12 12" width={12} height={12} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 1.05a4.95 4.95 0 1 0 0 9.9A4.95 4.95 0 0 0 6 1.05Zm.45 2.95a.45.45 0 0 0-.9 0v3a.45.45 0 0 0 .9 0v-3Zm0 4.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Z"
                fill="currentColor"
            />
        </svg>
    )
}

const ckBase: SVGProps<SVGSVGElement> = {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    fill: 'currentColor',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': true,
    focusable: false,
}

export function BoldIcon(props: IconProps) {
    return (
        <svg {...ckBase} {...props}>
            <path d="M10.187 17H5.773q-.956 0-1.364-.415-.41-.416-.409-1.323V4.738q0-.926.419-1.332.418-.405 1.354-.406h4.68q1.035 0 1.793.124.76.124 1.36.478.512.296.906.75a3.26 3.26 0 0 1 .808 2.162q0 2.102-2.167 3.075 2.846.879 2.847 3.421a3.76 3.76 0 0 1-2.296 3.504 6 6 0 0 1-1.517.377q-.857.11-2 .11zm-.217-6.217H7v4.087h3.069q2.965 0 2.965-2.072 0-1.061-.768-1.537-.768-.478-2.296-.478M7 5.13v3.619h2.606q1.093 0 1.69-.2a1.6 1.6 0 0 0 .91-.765q.247-.4.247-.897 0-1.06-.778-1.409-.778-.348-2.375-.348z" />
        </svg>
    )
}

export function ItalicIcon(props: IconProps) {
    return (
        <svg {...ckBase} {...props}>
            <path d="m9.586 14.633.021.004q-.054.502.393.962.123.125.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15q.711-.106 1.005-.334.235-.182.404-.597l2.416-9.55a1.05 1.05 0 0 0-.281-.823 1.1 1.1 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195q-.564.084-.823.296-.323.263-.623.79z" />
        </svg>
    )
}

export function UnderlineIcon(props: IconProps) {
    return (
        <svg {...ckBase} {...props}>
            <path d="M3 18v-1.5h14V18zm2.2-8V3.6c0-.4.4-.6.8-.6.3 0 .7.2.7.6v6.2c0 2 1.3 2.8 3.2 2.8s3.4-.9 3.4-2.9V3.6c0-.3.4-.5.8-.5.3 0 .7.2.7.5V10c0 2.7-2.2 4-4.9 4-2.6 0-4.7-1.2-4.7-4" />
        </svg>
    )
}

export function StrikethroughIcon(props: IconProps) {
    return (
        <svg {...ckBase} {...props}>
            <path d="M7 16.4c-.8-.4-1.5-.9-2.2-1.5a.6.6 0 0 1-.2-.5l.3-.6h1c1 1.2 2.1 1.7 3.7 1.7 1 0 1.8-.3 2.3-.6.6-.4.6-1.2.6-1.3.2-1.2-.9-2.1-.9-2.1h2.1c.3.7.4 1.2.4 1.7v.8l-.6 1.2c-.6.8-1.1 1-1.6 1.2a6 6 0 0 1-2.4.6c-1 0-1.8-.3-2.5-.6M6.8 9 6 8.3c-.4-.5-.5-.8-.5-1.6 0-.7.1-1.3.5-1.8.4-.6 1-1 1.6-1.3a6.3 6.3 0 0 1 4.7 0 4 4 0 0 1 1.7 1l.3.7c0 .1.2.4-.2.7-.4.2-.9.1-1 0a3 3 0 0 0-1.2-1c-.4-.2-1-.3-2-.4-.7 0-1.4.2-2 .6-.8.6-1 .8-1 1.5 0 .8.5 1 1.2 1.5.6.4 1.1.7 1.9 1H6.8z" />
            <path d="M3 10.5V9h14v1.5z" />
        </svg>
    )
}

export function BulletedListIcon(props: IconProps) {
    return (
        <svg {...ckBase} {...props}>
            <path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75m-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75m6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75m-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75" />
        </svg>
    )
}

export function NumberedListIcon(props: IconProps) {
    return (
        <svg {...ckBase} {...props}>
            <path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75M3.5 3v5H2V3.7H1v-1h2.5zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001q-.073.607-.333.988-.263.381-1.244 1.312H4.3v1h-4zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75" />
        </svg>
    )
}

export function LinkIcon(props: IconProps) {
    return (
        <svg {...ckBase} {...props}>
            <path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.8.8 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.7.7 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294zm5.494-5.335a.8.8 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.8.8 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955m-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184" />
        </svg>
    )
}
